//关于contractType的过滤器 给列表和详情使用
define('filters/appmng/contract-type.filter',['app', 'mainCons'], function (app, mainCons) {
    app.filter('contractTypeFilter', function () {
        return function (input) {
            if (!input) {
                return '';
            }
            var contractTypeTemp = mainCons.balanceConstant.contractType;
            var contractTypeArrays = ['2', '3', '4'];
            if (AUI.BaseJSUtil.contains(contractTypeArrays, input.contractType)) {
                return contractTypeTemp[input.contractType]
            }
            if (input.contractType == 1 && input.giftType == 1 && input.mediaType == 0) {
                return "现金"
            }
            if (input.contractType == 1 && input.giftType == 2 && input.mediaType == 0) {
                return "现金-充赠"
            }
            //纯赠送-华为自有媒体
            if (input.contractType == 5 && input.giftType == 1 && input.mediaType == 1) {
                return "纯赠送-华为自有媒体"
            }
            //充值赠送 充值赠送-通用
            if (input.contractType == 5 && input.giftType == 2 && input.mediaType == 0) {
                if (input.signParty == 1) {
                    return "充值赠送-通用"
                } else {
                    return "充值赠送"
                }
            }
            //充值赠送华-为自有媒体
            if (input.contractType == 5 && input.giftType == 2 && input.mediaType == 1) {
                return "充值赠送-华为自有媒体"
            }

            //纯赠送-通用 纯赠送
            if (input.contractType == 5 && (input.giftType == 1 || !input.giftType) && !input.mediaType) {
                if (input.signParty == 1) {
                    return "纯赠送-通用"
                } else {
                    return "纯赠送"
                }
            }

            //消耗返利-华为自有媒体
            if (input.contractType == 6 && input.mediaType == 1) {
                return "消耗返利-华为自有媒体"
            }
            //消耗返利-应用市场推广
            if (input.contractType == 6 && input.rebateType == 1) {
                return "消耗返利-应用市场推广"
            }
            //联运返利-游戏
            if (input.contractType == 6 && input.rebateType == 2) {
                return "联运返利-游戏"
            }
            //联运返利-应用
            if (input.contractType == 6 && input.rebateType == 3) {
                return "联运返利-应用"
            }
            //消耗返利-通用
            if (input.contractType == 6 && !input.rebateType) {
                return "消耗返利-通用"
            }

            return "--"

        };
    });
});

